export default __webpack_public_path__ + "static/media/arecanut.2a4d69aa.png";